import { I18n } from '@calendly/i18n'
import {
  DropdownMenuGroup,
  DropdownMenuGroupTitle,
  DropdownMenuItem,
} from '@calendly/ui/components/dropdown-menu'
import { BodyText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconStandard, colorTextSecondary } from '@calendly/ui/theme'

import { getAnswerTypeMenuItems, getQuestionTypeIcon } from './helpers'
import {
  questionTypeMenuGroupTitleCss,
  questionTypeMenuItemContentCss,
  questionTypeMenuItemDescriptionRowCss,
  questionTypeMenuItemIconSpacerCss,
  questionTypeMenuItemTitleRowCss,
} from './styles'

export const QuestionTypeMenuItems = ({
  onSelect,
  testIdPrefix = 'new-question-option',
}) => (
  <DropdownMenuGroup>
    <DropdownMenuGroupTitle className={questionTypeMenuGroupTitleCss}>
      {I18n.t('publisher.event_type_editor_crud.booking_page.question_type_header')}
    </DropdownMenuGroupTitle>
    {getAnswerTypeMenuItems().map(({ value, label, description }) => {
      const Icon = getQuestionTypeIcon(value)

      return (
        <DropdownMenuItem
          key={value}
          data-testid={`${testIdPrefix}-${value}`}
          onSelect={() => onSelect(value)}
        >
          <div className={questionTypeMenuItemContentCss}>
            <div className={questionTypeMenuItemTitleRowCss}>
              <UiIcon icon={Icon} size="small" color={colorIconStandard} title="" />
              <BodyText size="medium" weight="regular">{label}</BodyText>
            </div>
            <div className={questionTypeMenuItemDescriptionRowCss}>
              <span className={questionTypeMenuItemIconSpacerCss} aria-hidden />
              <BodyText color={colorTextSecondary} size="small" weight="regular">
                {description}
              </BodyText>
            </div>
          </div>
        </DropdownMenuItem>
      )
    })}
  </DropdownMenuGroup>
)
